module.exports = __webpack_public_path__ + "img/07.04e6c6d9.png";